/** Max length of an email address per RFC 5321 (also enforced in firestore.rules). */
export const MAX_EMAIL_LENGTH = 254;

/**
 * Pragmatic email check: one `@`, a non-empty local part, and a dotted domain.
 * Matches the browser's `input[type=email]` behaviour closely enough for a form
 * field; the authoritative check is always delivery, never a regex.
 */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

export function isValidEmail(value: string): boolean {
  return value.length <= MAX_EMAIL_LENGTH && EMAIL_PATTERN.test(value);
}
